export const mainVideo = 'https://youtube.com/embed/dCer2e0t8r8?autoplay=1'
